	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.Node.Component;


//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs/ref/Node/Component.js
// module id = 0
// module chunks = 0